import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Carousel from './Carousel';
import Stats from './Stats';
import LiveTrade from './LiveTrade';
import Faq from './Faq';
import TradingTools from './TradingTools';
import TrustAndPayments from './TrustAndPayments';

interface LiveTradeData {
  id: string;
  image: string;
  name: string;
  type: 'bought' | 'sold';
}

const FEATURE_DURATION = 7000;

const LandingPage = () => {
  const {t} = useTranslation();
  const [featureIndex, setFeatureIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const requestRef = useRef<number>(0);
  const startTimeRef = useRef<number>(0);


  const features = [
    {
      label: t('landing_page.carousel.features.multi_account.label'),
      title: t('landing_page.carousel.features.multi_account.title'),
      description: t('landing_page.carousel.features.multi_account.description')
    },
    {
      label: t('landing_page.carousel.features.community.label'),
      title: t('landing_page.carousel.features.community.title'),
      description: t('landing_page.carousel.features.community.description')
    },
    {
      label: t('landing_page.carousel.features.premium.label'),
      title: t('landing_page.carousel.features.premium.title'),
      description: t('landing_page.carousel.features.premium.description')
    }
  ];

  // Animation logic for carousel progress
  const animate = (time: number) => {
    if (!startTimeRef.current) startTimeRef.current = time;
    const elapsed = time - startTimeRef.current;
    const nextProgress = (elapsed / FEATURE_DURATION) * 100;

    if (nextProgress >= 100) {
      startTimeRef.current = time;
      setFeatureIndex((prev) => (prev + 1) % features.length);
      setProgress(0);
    } else {
      setProgress(nextProgress);
    }
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [featureIndex]);

  const handleManualSwitch = (index: number) => {
    setFeatureIndex(index);
    setProgress(0);
    startTimeRef.current = 0;
  };


  return (
      <div className="min-h-screen bg-white dark:bg-dark text-light-text dark:text-dark-text">
        <Carousel
            features={features}
            featureIndex={featureIndex}
            progress={progress}
            handleManualSwitch={handleManualSwitch}
        />

        <Stats/>
        <LiveTrade />
        <TradingTools/>
        <TrustAndPayments/>
        <Faq/>
      </div>
  );
};

export default LandingPage;